<template>
    <div>
        <select class="custom-select" >
            <option name="boleta" value="1" > Boleta Electronica</option>
            <option name="factura" value="2" > Factura Electronica</option>
            <option name="encargo" value="3" > Encargo</option>
            <option name="cotizacionFormal" value="4" > COTIZACION FORMAL</option>
            <option name="guia" value="4" > Guia de Despacho</option>
            <option name="cotizacion" value="4" > Cotizacion</option>

        </select>
    </div>
</template>

<script>
    export default {
        name: "DropDownComponent",
        props:['value', 'title']
    }
</script>

<style scoped>
    select{
        border: 1px solid;
        width: 15em;
    }
    div{
        text-align: center;
    }
</style>